<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9BTyqo/tc-custom/9780061869044.jpg?1716663321364" alt="This image is the cover for the book My Soul to Take, Thora Gudmundsdottir Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Soul to Take, Thora Gudmundsdottir Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A murder on the unforgiving Icelandic coast unearths a dark past in this thriller by the acclaimed author of <i>Last Rituals</i>.</b><br/><br/>Attorney and single mother Thóra Gudmundsdóttir is on the west coast of Iceland, where a client named Jonas is turning an old farm into a New Age spa. In this ruggedly beautiful region of lore and superstition, Thóra has no patience for local tales of hauntings. But some horrors are all too real—as when a young woman is brutally murdered, and Jonas becomes the chief suspect. <br/><br/>As Thóra digs deep into the farm's past, discovering long-buried secrets, her once-solid view of reality begins to waver. Could the farm truly be haunted? And more importantly, does its eerie past have some connection to the murder? When another body is discovered—looking very much like the first—Thóra is forced to put aside her doubts and confront a twisted killer.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yrsa Sigurdardottir
      </h2>
      
      <p class="authorDescription body article"><P>Yrsa Sigurdard&#211;ttir is an award-winning author of five children's novels and a division manager with one of Iceland's largest engineering firms. She lives with her family in Reykjav&#237;k, Iceland.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6561318f